import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {}

  settasks(event) {
    const target = event.target
    const id = target.value
    const model = target.dataset.model

    // Capture both elements synchronously while event.target is still available
    const taskWrapper = this.getTaskWrapper(model, target)
    const dropdown = this.getDropdown(model, target)

    // If no site selected, hide tasks and clear selection
    if (!id || id === "") {
      if (taskWrapper) {
        taskWrapper.classList.add("hidden")
      }
      if (dropdown) {
        // Über populateDropdown und nicht per innerHTML = "": ein <select> ganz ohne
        // Optionen sendet seinen Namen gar nicht mit, der Server sähe also kein task_id
        // und behielte die alte Aufgabe, während die Baustelle geleert wird. Mit
        // data-include-blank bleibt der Leer-Eintrag stehen und die Absicht "keine
        // Baustelle, keine Aufgabe" kommt an.
        this.populateDropdown(dropdown, [])
        this.resetTaskSelect(dropdown, 0)
      }
      return
    }

    fetch(`/sites/${id}/site_tasks`)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`)
        return response.json()
      })
      .then((data) => {
        this.populateDropdown(dropdown, data)
        // Reveal the task wrapper when the site has tasks, or when inline task
        // creation is enabled on this dropdown (so an empty site can still reach
        // the "create task" option). The value attribute is only present when
        // can_create_inline was true at render time.
        if (taskWrapper) {
          const canCreate = dropdown?.dataset?.taskSelectCanCreateValue === "true"
          if (data.length > 0 || canCreate) {
            taskWrapper.classList.remove("hidden")
          } else {
            taskWrapper.classList.add("hidden")
          }
        }
        this.resetTaskSelect(dropdown, parseInt(id))
      })
      .catch((error) => {
        console.error("Failed to fetch site tasks:", error)
      })
  }

  getTaskWrapper(model, target) {
    // Support custom wrapper ID for multi-entry cloned blocks
    const customWrapperId = target?.dataset?.wrapperId
    if (customWrapperId) {
      return document.getElementById(customWrapperId)
    }

    if (model === "timesheet") {
      return document.getElementById("time_sheet_task_ids_wrapper")
    } else if (model === "configurable_timesheet") {
      return document.getElementById("configurable_time_sheet_task_ids_wrapper")
    }
    return null
  }

  getDropdown(model, target) {
    // Support custom dropdown ID for multi-entry cloned blocks
    const customDropdownId = target?.dataset?.dropdownId
    if (customDropdownId) {
      return document.getElementById(customDropdownId)
    }

    if (model === "timesheet") {
      return document.getElementById("time_sheet_task_ids")
    } else if (model === "configurable_timesheet") {
      return document.getElementById("configurable_time_sheet_task_ids")
    } else {
      return document.getElementById("appointment_task_id")
    }
  }

  resetTaskSelect(dropdown, siteId) {
    if (!dropdown) return
    const taskSelectCtrl = this.application.getControllerForElementAndIdentifier(
      dropdown,
      "task-select",
    )
    if (taskSelectCtrl) {
      taskSelectCtrl.siteIdValue = siteId
      taskSelectCtrl.reinitialize()
      return
    }

    // Plain SlimSelect dropdown (no inline-creation wrapper): it snapshots its data on
    // init, so replacing the options underneath it leaves the visible list stale until
    // the wrapping select controller rebuilds. Same pattern as customer_site_filter.
    this.application.getControllerForElementAndIdentifier(dropdown, "select")?.refresh()
  }

  populateDropdown(dropdown, data) {
    if (!dropdown) return

    dropdown.innerHTML = ""
    // Opt-in via data-include-blank on the target select: an optional assignment needs
    // a way back to "no task". Dropdowns without the attribute keep the previous
    // behaviour of listing tasks only.
    if (dropdown.dataset.includeBlank !== undefined) {
      dropdown.appendChild(new Option(dropdown.dataset.includeBlank, ""))
    }
    data.forEach((item) => {
      const option = document.createElement("option")
      option.value = item.id
      option.text = item.name
      dropdown.appendChild(option)
    })
  }

  latetasks() {
    const elements = document.getElementsByClassName(`late_task`)
    if (elements.length === 0) return

    if (elements[0].classList.contains("hidden")) {
      elements[0].classList.remove("hidden")
    } else {
      elements[0].classList.add("hidden")
    }

    if (elements[1].classList.contains("hidden")) {
      elements[1].classList.remove("hidden")
    } else {
      elements[1].classList.add("hidden")
    }
  }
}
